var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BubbleAction",class:{disabled: !_vm.config.enabled}},[_c('img',{attrs:{"src":_vm.config.image,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }